/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Event_Text_FailedInputs */



/**
* | output |
* | --- |
* | "Event text copy failed" |
*
* @param {Copy_Event_Text_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_event_text_failed = /** @type {((inputs?: Copy_Event_Text_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Event_Text_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la copie du texte de l'événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopieren des Ereignistextes fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia del testo dell'evento non riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось скопировать текст события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al copiar el texto del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件文本复制失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテキストのコピーに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेक्स्ट कॉपी विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao copiar texto do evento")
	return /** @type {LocalizedString} */ ("Event text copy failed")
});